var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSortableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.551,
    height: 40,
    viewBox: "0 0 20.551 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12783",
    "data-name": "Grupo 12783",
    transform: "translate(-3 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4843",
    "data-name": "Grupo 4843",
    transform: "translate(23.551 10) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_keyboard_arrow_left_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2115",
    "data-name": "Caminho 2115",
    d: "M5.076,7.254,1.939,4.11,5.076.966,4.11,0,0,4.11,4.11,8.22Z",
    transform: "translate(7.535 6.165)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2116",
    "data-name": "Caminho 2116",
    d: "M0,0H20.551V20.551H0Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4844",
    "data-name": "Grupo 4844",
    transform: "translate(3 50) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_keyboard_arrow_left_24px-2",
    "data-name": "ic_keyboard_arrow_left_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2115-2",
    "data-name": "Caminho 2115",
    d: "M5.076,7.254,1.939,4.11,5.076.966,4.11,0,0,4.11,4.11,8.22Z",
    transform: "translate(7.535 6.165)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2116-2",
    "data-name": "Caminho 2116",
    d: "M0,0H20.551V20.551H0Z",
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSortableIcon);
export default __webpack_public_path__ + "static/media/arrowSortableIcon.6a8996c9.svg";
export { ForwardRef as ReactComponent };